module.exports = __webpack_public_path__ + "img/PyCharm_icon.9a28fa7b.png";